import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '@kodit/core/services';

//Guard koji sprecava pristup SubExpiredLayout-u
@Injectable({
  providedIn: 'root',
})
export class InactiveOrExpiredGuard implements CanActivate {
  constructor(
    private _router: Router,
    private jwtHelper: JwtHelperService,
    private auth: AuthService
  ) {}

  canActivate(): boolean {
    const token = this.auth.getToken;
    if (!token) {
      this._router.navigate(['/autentikacija/prijava']).then();
      return false;
    }

    const decoded = this.jwtHelper.decodeToken(token);
    const subEnd = decoded?.subscriptionEnd;

    if (!subEnd) {
      return false;
    }

    const expiration = new Date(subEnd);
    const now = new Date();

    const isExpired = expiration < now;

    // Ako nije istekao ili je aktivan, ne moze pristupiti InactiveOrExpiredLayout-u
    if (!isExpired && this.auth.getIsTenantActive) {
      this._router.navigate(['/dashboard']).then();
      return false;
    }

    return true;
  }
}
